import axios from 'axios';

export interface ConnectResult {
  text: string;
  variant: 'error' | 'info' | 'success';
}

// The backend sends the browser back from Microsoft with ?sharepoint=connected or ?sharepoint=error&reason=….
const REASONS: Record<string, string> = {
  access_denied: 'SharePoint was not connected. If Microsoft asked for admin approval, your company\'s Microsoft 365 admin needs to approve Strada first.',
  consent_required: 'Your company\'s Microsoft 365 admin needs to approve Strada before SharePoint can be connected.',
  expired: 'The Microsoft sign-in took too long or was already used. Please try again.',
  personal_account: 'Please sign in with your work Microsoft account. Personal accounts don\'t have SharePoint.',
  sign_in_failed: 'Microsoft sign-in failed. Please try again, or contact Strada support if it keeps happening.',
};

export function connectResult(result: string | null, reason: string | null): ConnectResult | null {
  if (result === 'connected') {
    return { text: 'SharePoint connected. Now choose the folder that holds your leases.', variant: 'success' };
  }
  if (result === 'error') {
    const known = reason !== null && reason in REASONS ? REASONS[reason] : undefined;
    return { text: known ?? `SharePoint could not be connected (${reason ?? 'unknown error'}).`, variant: 'error' };
  }
  return null;
}

export function requestError(error: unknown, action: string): string {
  if (axios.isAxiosError(error)) {
    const status = error.response?.status;
    if (status === 403) {
      return `Only workspace owners and admins can ${action}.`;
    }
    if (status === 409) {
      return 'The SharePoint sign-in has expired. Please reconnect SharePoint.';
    }
    const detail: unknown = error.response?.data?.detail;
    if (typeof detail === 'string' && detail !== '') {
      return `Could not ${action}: ${detail}.`;
    }
  }
  return `Could not ${action}. Please try again.`;
}
